import type {ReactElement} from 'react';
import React from 'react';
import {Modal} from '@Components/modal';
import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {LazyPanel} from '@Components/lazy-panel';
import type {SocialMediaSelectCoverPanelProps} from '@Panels/social-media-select-cover-panel';
import {useModalData} from "@Components/modal/hooks/useModalData";
import {useAppSelector} from "@/hooks";

const PANEL_ID = 'social-media-select-cover-panel';
export type SocialMediaSelectCoverModalProps = SocialMediaSelectCoverPanelProps;

export default function SocialMediaSelectCoverModal(): ReactElement<any> {
  const MAX_MOBILE_MODAL_HEIGHT_PX = 600;
  const MIN_MOBILE_MODAL_HEIGHT_PX = 400;
  const MIN_MODAL_HEIGHT_PX = 633;

  const modalData = useModalData(MODALS_IDS.SOCIAL_MEDIA_SELECT_COVER_MODAL);
  const isPanelLoading = useAppSelector((state) => {
    return state.lazyPanels.lazyPanelHashmap[PANEL_ID]?.isLoading ?? false;
  });

  const initialMobileModalHeight = modalData.height ? modalData.height : MIN_MOBILE_MODAL_HEIGHT_PX;
  const mobileModalHeight = initialMobileModalHeight > MAX_MOBILE_MODAL_HEIGHT_PX ? MIN_MOBILE_MODAL_HEIGHT_PX : initialMobileModalHeight;

  const modalHeight = isPanelLoading ?  `${MIN_MODAL_HEIGHT_PX}px` : 'fit-content';
  const modalWidth = '700px';

  return (
    <Modal modalId={MODALS_IDS.SOCIAL_MEDIA_SELECT_COVER_MODAL} modalHeight={modalHeight}   mobileHeight={`${mobileModalHeight}px`} modalWidth={modalWidth} panelId={PANEL_ID}>
      <LazyPanel
        lazyPanelId={PANEL_ID}
        panelDirectoryName="social-media-select-cover-panel"
        panelProps={{
          ...modalData.panelProps,
          panelId: PANEL_ID,
        }}
      />
    </Modal>
  );
}

export const openSelectCoverModal = (props: SocialMediaSelectCoverModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.SOCIAL_MEDIA_SELECT_COVER_MODAL,
      panelProps: props,
    })
  );
};
